import { PropsWithChildren } from 'react';

import { LoadingScreenSamFull } from '../components/LoadingScreen/LoadingScreenSamFull.js';
import { GlobalLoadingContext } from './consts.js';
import { useNewGlobalLoadingState } from './hooks/useNewGlobalLoadingState.js';

// NOTE: To show the loader locally, comment out the `<React.StrictMode>` tags in pkg/toolkit-frontend/src/main.tsx
export const GlobalLoadingContextProvider = ({ children }: PropsWithChildren) => {
  const state = useNewGlobalLoadingState();

  return (
    <GlobalLoadingContext.Provider value={state}>
      <LoadingScreenSamFull
        isLoading={state.showIndicator}
        what="Toolkit"
        wrapperProps={{ backgroundColor: 'surface1' }}
      />

      {children}
    </GlobalLoadingContext.Provider>
  );
};
